import React from "react";
import ReactDOM from "react-dom";
import { unregister as unregisterServiceWorker } from "./registerServiceWorker";
import WebFontLoader from "webfontloader";
// import injectTapEventPlugin from 'react-tap-event-plugin';

import "./styles/index.css";

// modules
import App from "./App";

// Needed for onTouchTap
// http://stackoverflow.com/a/34015469/988941
// injectTapEventPlugin();

WebFontLoader.load({
  google: {
    families: ["Varela Round", "Montserrat:400, 700", "Material Icons"],
  },
});

ReactDOM.render(<App />, document.getElementById("root"));

/* NOT register() — unregister().
 *
 * The build still emits a Workbox service-worker.js that precaches index.html,
 * and an earlier deploy registered it. A registration outlives the build that
 * created it: browsers that took that worker keep being served the precached
 * shell, so they load OLD chunk hashes and render old CSS against new markup —
 * which looks exactly like "the stylesheet is missing". Commenting the
 * register() call out stops NEW browsers taking it, but never releases the ones
 * that already did. This does. */
unregisterServiceWorker();
